export const RQ_GET_UNLOCKING_HISTORY_TREAD_API = {
  url:'reportingunlockhistory/trend/<%= divisionId %>/<%= fromDateStr %>/<%= toDateStr %>',
  method:'GET',
  auth:true,
};
